export const TRASHED_STATUS = 'trashed' as const;
